import { lazyLoadComponent } from '../../util-routing'

export const alertsModule = [
  {
    path: '/alerts.ashx',
    loaderBundle: () => import(/* webpackChunkName: "alerts-loaders" */ './loaders'),
    Component: lazyLoadComponent({
      chunkName: 'alerts',
      load: () => import(/* webpackChunkName: "alerts" */ './AlertsRoute'),
    }),
  },
]
